window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + '_crop_center' + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      // BEGIN SWATCHES
var selector = this.originalSelectorId;
if (variant) {
    var form = $(selector).closest('form');
    for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.size()) {
            radioButton.get(0).checked = true;
        }
    }
}
// END SWATCHES

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);

    },


    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Ahlem = {
    // All pages
    'common': {
      init: function() {

        function FixHeader() {
          if ($(window).scrollTop() >= 56) {
            $('.main_header').addClass('fixed-header');
            $('body').addClass('fixed');
          } else {
            $('.main_header').removeClass('fixed-header');
            $('body').removeClass('fixed');
          }
        }

        $(window).scroll(FixHeader);

        setInterval(function() {
          $('.top-banner').each(function() {
            var $cur = $(this).find('.current').removeClass('current');
            var $next = $cur.next().length ? $cur.next() : $(this).children().eq(0);
            $next.addClass('current');
          });
        }, 5000);

        //pop up modal
        if ($(".spec-details")[0]) {
          $(window).scroll(function() {
            var hT = $('.spec-details').offset().top,
              hH = $('.spec-details').outerHeight(),
              wH = $(window).height(),
              wS = $(this).scrollTop();
            if (wS > (hT + hH - wH)) {
              var cookieName = 'tplCookieConsent'; // The cookie name
              var cookieLifetime = 365; // Cookie expiry in days
              /**
               * Set a cookie
               * @param cname - cookie name
               * @param cvalue - cookie value
               * @param exdays - expiry in days
               */
              var _setCookie = function(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
              };
              /**
               * Get a cookie
               * @param cname - cookie name
               * @returns string
               */
              var _getCookie = function(cname) {
                var name = cname + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                  var c = ca[i];
                  while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                  }
                  if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                  }
                }
                return "";
              };
              /**
               * Should the cookie popup be shown?
               */
              var _shouldShowPopup = function() {
                if (_getCookie(cookieName)) {
                  return false;
                } else {
                  return true;
                }
              };
              // Show the cookie popup on load if not previously accepted
              if (_shouldShowPopup()) {
                $('#cookieModal').modal('show');
              }
              // Modal dismiss btn - consent
              $('#cookieModalConsent').on('click', function() {
                _setCookie(cookieName, 1, cookieLifetime);
              });
              $('#new-mc-embedded-subscribe').on('click', function() {
                _setCookie(cookieName, 1, cookieLifetime);
              });
              $(window).off('scroll');
            }
          });
        }



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'template_search': {
      init: function() {
        // JavaScript to be fired on the home page


        $.fn.domInsert = function(callback = 0) {
          console.log(this)
          var listen = (function() {
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
            return function(obj, callback) {
              if (!obj || !obj.nodeType === 1) return;
              if (MutationObserver) {
                var obs = new MutationObserver(function(mutations, observer) {
                  callback(mutations);
                })
                obs.observe(obj, {
                  childList: true,
                  subtree: true
                });
              } else if (window.addEventListener) {
                obj.addEventListener('DOMNodeInserted', callback, false);
              }
            }
          })();
          listElm = $(this)[0];
          listen(listElm, function(m) {
            var addedNodes = []
            m.forEach(record => record.addedNodes.length & addedNodes.push(...record.addedNodes))
            if (callback != 0)
              callback(addedNodes)
          });
        };

        $("body").domInsert(function(element) {
          //console.log(element[0].className);

          var modalVisible = element[0].className;
          console.log(modalVisible);
          if (modalVisible == "bc-modal-loading-icon") {
            setTimeout(function() {
              $('.bc-quickview-product-thumbs-list').slick({
                centerMode: false,
                infinite: false,
                centerPadding: '0',
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
                arrows: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                      centerMode: false,
                      infinite: false,
                      centerMode: true,
                      centerPadding: '20px',
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: false,
                      centerMode: false,
                      infinite: false,
                      centerPadding: '10px',
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                  }
                ]
              });
            }, 600);
          }
        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // collection template
    'template_collection': {
      init: function() {
        //sticky
        /*
        var sidebar = new StickySidebar('#sidebar', {
          topSpacing: 130
        });

        */

        $.fn.domInsert = function(callback = 0) {
          console.log(this)
          var listen = (function() {
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
            return function(obj, callback) {
              if (!obj || !obj.nodeType === 1) return;
              if (MutationObserver) {
                var obs = new MutationObserver(function(mutations, observer) {
                  callback(mutations);
                })
                obs.observe(obj, {
                  childList: true,
                  subtree: true
                });
              } else if (window.addEventListener) {
                obj.addEventListener('DOMNodeInserted', callback, false);
              }
            }
          })();
          listElm = $(this)[0];
          listen(listElm, function(m) {
            var addedNodes = []
            m.forEach(record => record.addedNodes.length & addedNodes.push(...record.addedNodes))
            if (callback != 0)
              callback(addedNodes)
          });
        };

        $("body").domInsert(function(element) {
          //console.log(element[0].className);

          var modalVisible = element[0].className;
          console.log(modalVisible);
          if (modalVisible == "bc-modal-loading-icon") {
            setTimeout(function() {
              $('.bc-quickview-product-thumbs-list').slick({
                centerMode: false,
                infinite: false,
                centerPadding: '0',
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true,
                arrows: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                      centerMode: false,
                      infinite: false,
                      centerMode: true,
                      centerPadding: '20px',
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: false,
                      centerMode: false,
                      infinite: false,
                      centerPadding: '10px',
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                  }
                ]
              });
            }, 600);
          }
        });

      }


    },
    // Cart template
    'template_our_culture': {
      init: function() {
        $(window).on("load scroll", function() {
          if ($(window).scrollTop() >= 50) {
            $('.section_menu').addClass('fixed-header');
          } else {
            $('.section_menu').removeClass('fixed-header');
          }
        });

        $('.navigation__link').bind('click', function(e) {
          e.preventDefault(); // prevent hard jump, the default behavior

          var target = $(this).attr("href"); // Set the target as variable

          // perform animated scrolling by getting top-position of target-element and set it as scroll target
          $('html, body').stop().animate({
            scrollTop: $(target).offset().top
          }, 600, function() {
            location.hash = target; //attach the hash (#jumptarget) to the pageurl
          });

          return false;
        });
        $(window).scroll(function() {
          var scrollDistance = $(window).scrollTop();

          // Show/hide menu on scroll
          //if (scrollDistance >= 850) {
          //		$('nav').fadeIn("fast");
          //} else {
          //		$('nav').fadeOut("fast");
          //}

          // Assign active class to nav links while scolling
          $('.page-section').each(function(i) {
            if ($(this).position().top <= scrollDistance + 100) {
              $('.navigation a.active').removeClass('active');
              $('.navigation a').eq(i).addClass('active');
            }
          });
        }).scroll();


      },
      finalize: function() {



      }
    },
    // product template
    'template_product': {
      init: function() {
        //  var sidebar = new StickySidebar('#sidebar', {topSpacing: 90, minWidth: 1024, containerSelector: '.row_section'});

        var sidebar2 = new StickySidebar('#fixed_details', {
          topSpacing: 90,
          bottomSpacing: 40,
          containerSelector: false,
          innerWrapperSelector: '.sidebar__inner',
          resizeSensor: true,
          stickyClass: 'is-affixed',
          minWidth: 768
        });
        (function() {
          function hasClass(el, cls) {
            if (el.className.match('(?:^|\\s)' + cls + '(?!\\S)')) {
              return true;
            }
          }

          function addClass(el, cls) {
            if (!el.className.match('(?:^|\\s)' + cls + '(?!\\S)')) {
              el.className += ' ' + cls;
            }
          }

          function delClass(el, cls) {
            el.className = el.className.replace(new RegExp('(?:^|\\s)' + cls + '(?!\\S)'), '');
          }

          function elementFromTop(elem, classToAdd, distanceFromTop, unit) {
            var winY = window.innerHeight || document.documentElement.clientHeight,
              distTop = elem.getBoundingClientRect().top,
              distPercent = Math.round((distTop / winY) * 100),
              distPixels = Math.round(distTop),
              distUnit;
            distUnit = unit == 'percent' ? distPercent : distPixels;
            if (distUnit <= distanceFromTop) {
              if (!hasClass(elem, classToAdd)) {
                addClass(elem, classToAdd);
              }
            } else {
              delClass(elem, classToAdd);
            }
          }
          // params: element id, class to add, distance from top, unit ('percent' or 'pixels')
          window.addEventListener('scroll', function() {
            var showSidebar = elementFromTop(document.getElementById('view_port'), 'element-from-top', 80, 'percent');
            if ($('.in_view').hasClass('element-from-top')) {
              $('.sidebar').addClass("opacity");
            } else {
              $('.sidebar').removeClass("opacity");
            }
          }, false);
        })();
      }
    },
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Ahlem;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');
      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Product Details Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product Details pg.
 * template.
 *
 *
 */
//new product details code
var colorTitle;
var variantDetails;

function easy_zoom() {
  var img = $('.image-zoom');
  $('#img_01').on('click', function() {
    img.removeData('elevateZoom');
    img.removeData('zoomImage');
    if ($('.enabled').length === 0) {
      if ($('.zoomContainer').length) {
        $('.zoomContainer').show();
        $(this).toggleClass('enabled');
      } else {
        $('#img_01').elevateZoom({
          zoomType: "inner",
          cursor: "crosshair",
          loadingIcon: true,
          gallery: 'gallery_01',
        });
      }
    } else {
      $(this).toggleClass('enabled');
      $('.zoomContainer').hide();
    }
  });
}
//easy_zoom();
//product thumbnail click
function swapThumbs() {
  $(".thumb-link").click(function(e) {
    e.preventDefault();
    $('.zoomContainer').remove();
    var mainImage = $(this).data("image");
    var zoomImage = $(this).data("zoom-image");
    $('.thumb-link').removeClass('active');
    $(this).addClass('active');
    $('.featured_img').attr('src', mainImage.replace('thumb', 'large'));
    $('.featured_img').attr('data-zoom-image', zoomImage);
  });
}

function slickCarousel() {
  $('.mobile_prod_slider').slick({
    centerMode: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  });
}

function destroyCarousel() {
  if ($('.mobile_prod_slider').hasClass('slick-initialized')) {
    $('.mobile_prod_slider').slick('destroy');
  }
}
//swapThumbs();
//change variants
$(function() {
  $('.swatch :radio').change(function() {
    //change thumbnail icons when clicking prod_variants
    $('#SingleOptionSelector-0').val($(this).data('val')).trigger('change');
    $('#SingleOptionSelector-1').val($(this).data('lens')).trigger('change');
    //make sure the zoom image is switching
    var zoomImg = $(this).data("image");
    var _url_one = $(this).data("thumbnail_one");
    var _url_two = $(this).data("thumbnail_two");
    var _url_three = $(this).data("thumbnail_three");
    var _url_four = $(this).data("thumbnail_four");
    var _url_five = $(this).data("thumbnail_five");
    var _url_six = $(this).data("thumbnail_six");
    colorTitle = $(this).data("title");
    variantDetails = $(this).data("details");
    $('.spec_details').empty();
    $('.spec_details').append(variantDetails);
    $('.product_color').empty();
    $('.product_color').append(colorTitle);
    $('.alt_img').empty();
    $('.zoomContainer').remove();
    //$('.primary_img').find('img').attr('src',mainCollection_img.replace('thumb','large'));
    $('.featured_img').attr('data-zoom-image', zoomImg);
    $(".thumb_gallery").empty();
    //check is empty
    if (_url_one == "" || _url_one == null) {
      var _thumb_li_one = "";
    } else {
      _thumb_li_one = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + _url_one + '" data-zoom-image="' + _url_one + '" data-product-single-thumbnail><img src="' + _url_one + '" alt="product-color-' + colorTitle + '" /></a></li>';
    }
    if (_url_two == "" || _url_two == null) {
      var _thumb_li_two = "";
    } else {
      _thumb_li_two = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + _url_two + '" data-zoom-image="' + _url_two + '" data-product-single-thumbnail><img src="' + _url_two + '" alt="sideview product-color-' + colorTitle + '" /></a></li>';
      $(".alt_img").append('<img src="' + _url_two + '" class="img-fluid" alt="alt image" />');
    }
    if (_url_three == "" || _url_three == null) {
      var _thumb_li_three = "";
    } else {
      _thumb_li_three = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + _url_three + '" data-zoom-image="' + _url_three + '" data-product-single-thumbnail><img src="' + _url_three + '" alt="frontview product-color-' + colorTitle + '" /></a></li>';
    }
    if (_url_four == "" || _url_four == null) {
      var _thumb_li_four = "";
    } else {
      _thumb_li_four = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + _url_four + '" data-zoom-image="' + _url_four + '" data-product-single-thumbnail><img src="' + _url_four + '" alt="alt sideview product-color-' + colorTitle + '" /></a></li>';
    }
    if (_url_five == "" || _url_five == null) {
      var _thumb_li_five = "";
    } else {
      _thumb_li_five = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + _url_five + '" data-zoom-image="' + _url_five + '" data-product-single-thumbnail><img src="' + _url_five + '" alt="front view product-color-' + colorTitle + '" /></a></li>';
    }
    if (_url_six == "" || _url_six == null) {
      var _thumb_li_six = "";
    } else {
      _thumb_li_six = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + _url_six + '" data-zoom-image="' + _url_six + '" data-product-single-thumbnail><img src="' + _url_six + '" alt="sideview product-color-' + colorTitle + '" /></a></li>';
    }
    var _gallery_array = [_thumb_li_two, _thumb_li_three, _thumb_li_four, _thumb_li_five, _thumb_li_six];
    $(".thumb_gallery").append(_gallery_array);
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    //swapThumbs();
    //need to reload image zoom
    //Re-create
    /*
        $('.zoomContainer').remove();
			imageElement.removeData('elevateZoom');
			imageElement.removeData('zoomImage');
			imageElement.attr('src',e.target.result);
			imageElement.attr('data-zoom-image',imageElement.src);

			imageElement.elevateZoom({
				zoomType	: "lens",
				lensSize	: 200
			});
      */
    //
    destroyCarousel();
    $(".mobile_prod_gallery").empty();
    $(".mobile_prod_gallery").append('<div class="mobile_prod_slider onstart_slider">' + _thumb_li_one + ' ' + _thumb_li_two + ' ' + _thumb_li_three + ' ' + _thumb_li_four + ' ' + _thumb_li_five + ' </div>');
    slickCarousel();
  });
});
$('.product_thumb_slider').on('init', function(event, slick) {
  //load thumbnail images
  swatch_slider();
  //make the thumbnails clickable
  //swapThumbs();
  //product sticky
});
//load thumbnails and all content on page load
function swatch_slider() {
  colorTitle = $('[data-selected]>.build_gallery').data("title");
  variantDetails = $('[data-selected]>.build_gallery').data("details");
  $('.product_color').append(colorTitle);
  $('.spec_details').append(variantDetails);
  var thumb_img_one = $('[data-selected]>.build_gallery').data("thumbnail_one");
  var thumb_img_two = $('[data-selected]>.build_gallery').data("thumbnail_two");
  var thumb_img_three = $('[data-selected]>.build_gallery').data("thumbnail_three");
  var thumb_img_four = $('[data-selected]>.build_gallery').data("thumbnail_four");
  var thumb_img_five = $('[data-selected]>.build_gallery').data("thumbnail_five");
  var thumb_img_six = $('[data-selected]>.build_gallery').data("thumbnail_six");
  //console.log(thumb_img_six);
  //$(this).closest('.product_item').find('.primary_collection_img').attr('src',mainCollection_img.replace('thumb','large'));
  if (thumb_img_one == "" || thumb_img_one == null) {
    var thumb_li_one = "";
  } else {
    thumb_li_one = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + thumb_img_one + '" data-zoom-image="' + thumb_img_one + '" data-product-single-thumbnail><img src="' + thumb_img_one + '" alt="product-color-' + colorTitle + '" /></a></li>';
  }
  if (thumb_img_two == "" || thumb_img_two == null) {
    var thumb_li_two = "";
  } else {
    thumb_li_two = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + thumb_img_two + '" data-zoom-image="' + thumb_img_two + '" data-product-single-thumbnail><img src="' + thumb_img_two + '" alt="sideview product-color-' + colorTitle + '" /></a></li>';
    //load alt img
    //$('.alt_img').attr('src',thumb_img_two.replace('thumb','large'));
    $(".alt_img").append('<img src="' + thumb_img_two + '" class="img-fluid" alt="alt image" />');
    //$(".alt_img_1").append('<img src="' + thumb_img_on + '" class="img-fluid" alt="alt image" />');
  }
  if (thumb_img_three == "" || thumb_img_three == null) {
    var thumb_li_three = "";
  } else {
    thumb_li_three = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + thumb_img_three + '" data-zoom-image="' + thumb_img_three + '" data-product-single-thumbnail><img src="' + thumb_img_three + '" alt="Alt faceshot product-color-' + colorTitle + '" /></a></li>';
  }
  if (thumb_img_four == "" || thumb_img_four == null) {
    var thumb_li_four = "";
  } else {
    thumb_li_four = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + thumb_img_four + '" data-zoom-image="' + thumb_img_four + '" data-product-single-thumbnail><img src="' + thumb_img_four + '" alt="alt sideshot product-color-' + colorTitle + '" /></a></li>';
  }
  if (thumb_img_five == "" || thumb_img_five == null) {
    var thumb_li_five = "";
  } else {
    thumb_li_five = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + thumb_img_five + '" data-zoom-image="' + thumb_img_five + '" data-product-single-thumbnail><img src="' + thumb_img_five + '" alt="Faceshot-product-color-' + colorTitle + '" /></a></li>';
  }
  if (thumb_img_six == "" || thumb_img_six == null) {
    var thumb_li_six = "";
  } else {
    thumb_li_six = '<li class="col-12">' + '<a class="thumb-link" href="#" data-image="' + thumb_img_six + '" data-zoom-image="' + thumb_img_six + '" data-product-single-thumbnail><img src="' + thumb_img_six + '" alt="Sideshot-' + colorTitle + '" /></a></li>';
  }
  var gallery_array = [thumb_li_two, thumb_li_three, thumb_li_four, thumb_li_five, thumb_li_six];
  $(".thumb_gallery").append(gallery_array);
}
//load mobile product gallery
//product slider
$('.mobile_prod_slider').on('init', function(event, slick) {
  //load images
  product_slider();
});

function product_slider() {
  var mobile_img_one = $('[data-selected]>.build_gallery').data("thumbnail_one");
  var mobile_img_two = $('[data-selected]>.build_gallery').data("thumbnail_two");
  var mobile_img_three = $('[data-selected]>.build_gallery').data("thumbnail_three");
  var mobile_img_four = $('[data-selected]>.build_gallery').data("thumbnail_four");
  var mobile_img_five = $('[data-selected]>.build_gallery').data("thumbnail_five");
  if (mobile_img_one == "" || mobile_img_one == null) {
    var mobile_li_one = "";
  } else {
    mobile_li_one = '<div><img src="' + mobile_img_one + '" /></div>';
  }
  if (mobile_img_two == "" || mobile_img_two == null) {
    var mobile_li_two = "";
  } else {
    mobile_li_two = '<div><img src="' + mobile_img_two + '"  /></div>';
  }
  if (mobile_img_three == "" || mobile_img_three == null) {
    var mobile_li_three = "";
  } else {
    mobile_li_three = '<div><img src="' + mobile_img_three + '"/></div>';
  }
  if (mobile_img_four == "" || mobile_img_four == null) {
    var mobile_li_four = "";
  } else {
    mobile_li_four = '<div><img src="' + mobile_img_four + '"/></div>';
  }
  if (mobile_img_five == "" || mobile_img_five == null) {
    var mobile_li_five = "";
  } else {
    mobile_li_five = '<div><img src="' + mobile_img_five + '"/></div>';
  }
  var prod_gallery_array = [mobile_li_one, mobile_li_two, mobile_li_three, mobile_li_four, mobile_li_five];
  ///console.log(prod_gallery_array);
  $(".mobile_prod_gallery").append('<div class="mobile_prod_slider onstart_slider">' + mobile_li_one + ' ' + mobile_li_two + ' ' + mobile_li_three + ' ' + mobile_li_four + ' ' + mobile_li_five + ' </div>');
}
product_slider();
$('.mobile_prod_slider').slick({
  centerMode: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
});
if ('ontouchstart' in document.documentElement) {
  //this is mobile
  //  console.log($(this).width());
  var w = $(this).width();
  if (w <= 668) {
    if ($(".swatch")[0]) {
      $('.swatch').appendTo('.product_options_mobile');
    }
  }
} else {}


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }



  if (!Cookies.get('popup')) {
        setTimeout(function() {
           $('#notification_modal').modal();
        }, 1000);
      }
      $('#notification_modal').on('shown.bs.modal', function () {
        // bootstrap modal callback function
        // set cookie
        Cookies.set('popup', 'valid', { expires: 10, path: "/" }); // need to set the path to fix a FF bug
      });

  //add to cart
  jQuery(function() {
    CartJS.init(foo, {
      requestBodyClass: 'cart-loading',
      "moneyFormat": "",
      "moneyWithCurrencyFormat": ""
    });
  });
  //mobile menu
  var isLateralNavAnimating = false;
  //open/close lateral navigation
  $('.cd-nav-trigger').on('click', function(event) {
    event.preventDefault();
    //stop if nav animation is running
    if (!isLateralNavAnimating) {
      if ($(this).parents('.csstransitions').length > 0) isLateralNavAnimating = true;
      $('.cd-side-nav').toggleClass('nav-is-visible');
      $( '.cart-header' ).removeClass( "_active" );
      $('body').toggleClass('overflow_hidden');
      $('.cd-nav-trigger').toggleClass('nav-is-visible');
      $('.cd-side-nav').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
        //animation is over
        isLateralNavAnimating = false;
      });
    }
  });

  $( ".cart-trigger" ).click(function(event) {
    event.preventDefault();
    $( '.cart-header' ).toggleClass( "_active" );
  });

  $('.quick-pay-btn').click(function(){
    $(this).text(function(i,old){
        return old=='Quick Pay' ?  'Close' : 'Quick Pay';
    });
    $( '.collapse' ).toggleClass( "show" );
});

  //cookies banner
  /*
  $("#cookies").addClass("display");
     $("#close-cookies").click(function(){
      event.preventDefault();
      $("#cookies").addClass("close-cookies");
    });
    */
  //close all modals before opening new one
  $('.modal').on('show.bs.modal', function() {
    $('.modal').not($(this)).each(function() {
      $(this).modal('hide');
    });
  });
  //click on item and show submenu
  $('.has-children > a').on('click', function(event) {
    var selectedItem = $(this);
    event.preventDefault();
    if (selectedItem.parent('li').hasClass('selected')) {
      selectedItem.parent('li').removeClass('selected');
    } else {
      $('.cd-side-nav').find('.has-children.selected').removeClass('selected');
      selectedItem.parent('li').addClass('selected');
    }
  });
  //sticky header

  $('#search_form_modal').on('shown.bs.modal', function() {
    $('.search_store').trigger('focus');
  });
  //Search Modal (remove backdrop)
  $('#search_form_modal').on('show.bs.modal', function(e) {
    $('body').addClass('no_backdrop');
  });
  $('#search_form_modal').on('hidden.bs.modal', function(e) {
    $('body').removeClass('no_backdrop');
  });


  if ($('.child li').hasClass('active')) {
    $(".child .active").closest('.list-item').addClass("active");

  }

  $(function() { // TOGGLE CLASS ON ELEMENT
     $(".search-trigger").on("click", function() {
       $('.search').toggleClass('open');
       $('.search .form-control').focus();
     });
   }); //END TOGGLE CLASS

   $(function() {  // REMOVE CLASS WHEN YOU CLICK, EXCLUDE ELEMENTS
     var ignore= Array(".search-trigger", // elements to ignore
                       ".search_store");
     ignore.forEach(function (item) { // loop through ignore array
       $(item).click(function(){ return false; }); // ignore item
     });
     $(document).on("click", function() { // remove class when you click anywhere else
       $(".search").removeClass('open'); });
   });
   // END REMOVE CLASS

/*
(function() {
  $(function() {
    return $("[data-sticky_column]").stick_in_parent({
      parent: "[data-sticky_parent]"
    });
  });
$(window).on("resize", (function(_this) {
    return function(e) {
      return $(document.body).trigger("sticky_kit:recalc");
    };
  })(this));
}).call(this);
*/

  //homepage slider
  //slider
  $('.fade-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    fade: true,
    cssEase: 'linear'
  });
  //homepage youtube pop-up
  $(function() {
    $(".youtube").YouTubeModal({
      autoplay: 1
    });
  });
  //home page quote slider
  $('.quotes_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: false,
    asNavFor: '.quotes_slider',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  //collections pg.



  $(".prod-collection-thumb").on('click mouseover', function(e) {
    e.preventDefault();
    //var src = $(this).attr('href');
    var mainCollection_img = $(this).data("image");
    var srcset_imgs = $(this).data("srcset");
    var prodLink = $(this).data("url");
    var prodTitle = $(this).data("title");
    $(this).closest('.product_item').find('.primary_collection_img').attr('src', mainCollection_img.replace('thumb', 'large'));
    $(this).closest('.product_item').find('.primary_collection_img').attr('srcset', srcset_imgs);
    $(this).closest('.product_item').find('.product_link').attr("href", prodLink);
    $(this).closest('.product_item').find('.color_name').html(" " + prodTitle);
    $('.prod-collection-thumb').removeClass('active');
    $(this).addClass('active');
  });


  // init Masonry
  /*
  var $grid = $('.grid').masonry({
    itemSelector: '.grid-item',
    percentPosition: true,
    columnWidth: '.grid-sizer'
  });
  // layout Masonry after each image loads
  $grid.imagesLoaded().progress( function() {
    $grid.masonry();
  });
  var lazyLoadInstances = [];
  // The "lazyLazy" instance of lazyload is used (kinda improperly)
  // to check when the .horzContainer divs enter the viewport
  var lazyLazy = new LazyLoad({
    //elements_selector: ".horzContainer",
    // When the .horzContainer div enters the viewport...
    callback_set: function(el) {
      // ...instantiate a new LazyLoad on it
      var oneLL = new LazyLoad({
        container: el
      });
      $(".prod-collection-thumb").on('click mouseover', function(e) {
        e.preventDefault();
        //var src = $(this).attr('href');
        var mainCollection_img = $(this).data("image");
        var srcset_imgs = $(this).data("srcset");
        var prodLink = $(this).data("url");
        var prodTitle = $(this).data("title");
        $(this).closest('.product_item').find('.primary_collection_img').attr('src', mainCollection_img.replace('thumb', 'large'));
        $(this).closest('.product_item').find('.primary_collection_img').attr('srcset', srcset_imgs);
        $(this).closest('.product_item').find('.product_link').attr("href", prodLink);
        $(this).closest('.product_item').find('.color_name').html(" " + prodTitle);
        $('.prod-collection-thumb').removeClass('active');
        $(this).addClass('active');
      });
      // Optionally push it in the lazyLoadInstances
      // array to keep track of the instances
      lazyLoadInstances.push(oneLL);


    }
  });
    */




  //product qty click
  // This button will increment the value
  $('.qtyplus').click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(0);
    }
  });
  //Product details thumbnails slider
  $('.product_thumb_slider').slick({
    centerMode: false,
    infinite: false,
    centerPadding: '0',
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          infinite: false,
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: false,
          infinite: false,
          centerPadding: '10px',
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      }
    ]
  });

$( ".lense-btn" ).click(function() {
  $( ".panel-body" ).collapse();
});


  //Lens slider
  $('.lens_slider').slick({
    centerMode: false,
    centerPadding: '20px',
    slidesToShow: 6,
    slidesToScroll: 6,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: '10px',
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      }
    ]
  });
  //clipons slider
  $('.clipon_slider').slick({
    centerMode: false,
    centerPadding: '60px',
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2
        }
      }
    ]
  });
  //campaigns
  $('.campaign_slider').each(function(idx, item) {
    var carouselId = "carousel" + idx;
    this.id = carouselId;
    $(this).slick({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: false,
      adaptiveHeight: true,
    });
  });


var placeSearch, autocomplete;
var componentForm = {
    locality: 'long_name'
};


  // Create the autocomplete object, restricting the search to geographical
  // location types.
  autocomplete = new google.maps.places.Autocomplete(
      /** @type {!HTMLInputElement} */
      (document.getElementById('autocomplete'))
      );

  // When the user selects an address from the dropdown, populate the address
  // fields in the form.
  autocomplete.addListener('place_changed', fillInAddress);


function fillInAddress() {
  // Get the place details from the autocomplete object.
  var place = autocomplete.getPlace();

  //console.log(place.formatted_address);



//document.getElementById("bh-sl-address").value = place.formatted_address;

/*
  for (var component in componentForm) {
    document.getElementById(component).value = '';
    document.getElementById(component).disabled = false;
  }
  */

  // Get each component of the address from the place details
  // and fill the corresponding field on the form.
  /*
  for (var i = 0; i < place.address_components.length; i++) {
    var addressType = place.address_components[i].types[0];
    if (componentForm[addressType]) {
      var val = place.address_components[i][componentForm[addressType]];
      document.getElementById(addressType).value = val;
    }
  }
  */
}

//MAP
$(function() {
	$('#bh-sl-map-container').storeLocator({
		'dataType': 'json',
		'dataLocation': 'https://ahlem.frhdesigns.com/wp-content/themes/frh/lib/json_stores4.php',
    markerCluster: {
               imagePath: 'https://ahlem.frhdesigns.com/wp-content/themes/frh/assets/images/m'
        },
    catMarkers : {
				'Restaurant' : ['//devahlem.myshopify.com/cdn/shop/t/4/assets/blk-marker.png?v=48681222298914356511588358410', 32, 32],
				'Cafe' : ['//devahlem.myshopify.com/cdn/shop/t/4/assets/blk-marker.png?v=48681222298914356511588358410', 32, 32]
			},
    'addressID' : 'autocomplete',
    'defaultLoc': false,
    'maxDistance': true,
		'defaultLat': '34.0588279',
		'defaultLng' : '-118.2796026',
    'storeLimit'      : 50,
		'distanceAlert'    : 100,
    'fullMapStartBlank' : 3,
    'slideMap'  : false,
    'loading'   : true,
    'listColor1' : '#ffffff',
		'listColor2' : '#eeeeee',
    'loadingContainer'  : 'bh-sl-loading',
    'callbackSuccess' : function ( dataLength ) {
      $('.bh-sl-container').addClass('_active');
   },
    'mapSettings' : {
      zoom : 10,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoomControl: true,
      scaleControl: true,
      zoomControlOptions: {
       position: google.maps.ControlPosition.RIGHT_CENTER
   },
      mapTypeControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles : [
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "stylers": [
            {
                "hue": "#00aaff"
            },
            {
                "saturation": -100
            },
            {
                "gamma": 2.15
            },
            {
                "lightness": 12
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": 24
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 57
            }
        ]
    }
]}
	});
	});

});
